import React, { HTMLAttributes, useCallback, useMemo } from 'react';
import startsWith from 'lodash/startsWith';
import { marked } from 'marked';
import useHistory from '../../Router/useHistory';
import Content from '../../styled/Content';
import RELOAD_TARGETS from '../../Router/reloadTargets';

interface IHtmlContent {
  html?: string;
  limitWidth?: boolean;
  markdown?: string;
  textAlt?: boolean;
}

const HtmlContent = ({
  html,
  limitWidth,
  markdown,
  textAlt,
  ...divProps
}: IHtmlContent & HTMLAttributes<HTMLDivElement>) => {
  const { push } = useHistory();
  const content = useMemo(
    () => (html && { __html: html }) || (markdown && { __html: marked(markdown) }) || null,
    [html, markdown],
  );

  const click = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    const clicked = e.target as HTMLAnchorElement;
    if (clicked.nodeName !== 'A') {
      return;
    }
    if (clicked.target === '_blank') {
      return;
    }

    if (!startsWith(clicked.href, location.origin)) {
      e.preventDefault();
      window.open(clicked.href, '_blank');
      return;
    }

    const shouldReload = !!RELOAD_TARGETS.find((t) => clicked.href.indexOf(t) >= 0);

    if (shouldReload) {
      return;
    }

    e.preventDefault();
    const path = clicked.href.replace(location.origin, '');
    push(path);
  }, []);

  if (!content) {
    return null;
  }

  return (
    <Content limitWidth={limitWidth} textAlt={textAlt}>
      <div {...divProps} dangerouslySetInnerHTML={content} onClick={click} />
    </Content>
  );
};

export default HtmlContent;
